"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// Check URL parameters and apply filters on page load
(function () {
  var urlParams = new URLSearchParams(window.location.search);
  var sectorParam = urlParams.get('sectors');
  var applicationParam = urlParams.get('applications');
  var bngParam = urlParams.get('bng');
  if (sectorParam || applicationParam || bngParam) {
    jQuery(document).ready(function ($) {
      // Pre-select dropdowns based on URL params
      if (sectorParam) {
        $('#sectors').val(sectorParam);
      }
      if (applicationParam) {
        $('#applications').val(applicationParam);
      }
      if (bngParam) {
        if (bngParam === '.bng-yes') {
          $('#bng').val('.bng-yes');
        } else if (bngParam === '.bng-no') {
          $('#bng').val('.bng-no');
        }
      }

      // Trigger filter automatically after a short delay to let the page load
      setTimeout(function () {
        $('#sectors, #applications, #bng').trigger('change');
      }, 300);
    });
  }
})();
jQuery(document).ready(function ($) {
  if ($('.sf__solutions').length) {
    var initDesktopBasketFollow = function initDesktopBasketFollow() {
      var basket = document.querySelector('.sf__basket');
      var section = document.querySelector('.sf');
      var basketWrapper = basket ? basket.parentElement : null;
      if (!basket || !section || !basketWrapper) {
        return;
      }
      var placeholder = basketWrapper.querySelector('.sf__basket-placeholder');
      if (!placeholder) {
        placeholder = document.createElement('div');
        placeholder.className = 'sf__basket-placeholder';
        basketWrapper.insertBefore(placeholder, basket);
      }
      var ticking = false;
      var resetBasket = function resetBasket() {
        basket.classList.remove('sf__basket--fixed', 'sf__basket--bottom');
        placeholder.classList.remove('sf__basket-placeholder--active');
        placeholder.style.height = '';
        basket.style.width = '';
        basket.style.left = '';
        basket.style.top = '';
        basket.style.bottom = '';
      };
      var updateBasketPosition = function updateBasketPosition() {
        if (window.innerWidth < 1024) {
          resetBasket();
          ticking = false;
          return;
        }
        var adminBar = document.querySelector('#wpadminbar');
        var siteHeader = document.querySelector('header, .site-header, .header');
        var adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
        var headerHeight = siteHeader ? siteHeader.offsetHeight : 0;
        var topOffset = adminBarHeight + headerHeight + 20;
        var sectionRect = section.getBoundingClientRect();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var sectionTop = sectionRect.top + scrollTop;
        var sectionBottom = sectionTop + section.offsetHeight;
        var basketHeight = basket.offsetHeight;
        placeholder.classList.add('sf__basket-placeholder--active');
        var placeholderRect = placeholder.getBoundingClientRect();
        var placeholderTop = placeholderRect.top + scrollTop;
        var placeholderLeft = placeholderRect.left;
        var placeholderWidth = placeholderRect.width;
        var fixedStart = placeholderTop - topOffset;
        var fixedEnd = sectionBottom - topOffset - basketHeight;
        placeholder.style.height = "".concat(basketHeight, "px");
        if (scrollTop < fixedStart) {
          basket.classList.remove('sf__basket--fixed', 'sf__basket--bottom');
          placeholder.classList.remove('sf__basket-placeholder--active');
          basket.style.width = '';
          basket.style.left = '';
          basket.style.top = '';
          basket.style.bottom = '';
          ticking = false;
          return;
        }
        if (scrollTop >= fixedEnd) {
          basket.classList.remove('sf__basket--fixed');
          basket.classList.add('sf__basket--bottom');
          placeholder.classList.add('sf__basket-placeholder--active');
          basket.style.width = "".concat(placeholderWidth, "px");
          basket.style.left = '';
          basket.style.top = '';
          basket.style.bottom = '0';
          ticking = false;
          return;
        }
        basket.classList.remove('sf__basket--bottom');
        basket.classList.add('sf__basket--fixed');
        placeholder.classList.add('sf__basket-placeholder--active');
        basket.style.width = "".concat(placeholderWidth, "px");
        basket.style.left = "".concat(placeholderLeft, "px");
        basket.style.top = "".concat(topOffset, "px");
        basket.style.bottom = '';
        ticking = false;
      };
      var requestUpdateBasketPosition = function requestUpdateBasketPosition() {
        if (!ticking) {
          window.requestAnimationFrame(updateBasketPosition);
          ticking = true;
        }
      };
      updateBasketPosition();
      window.addEventListener('scroll', requestUpdateBasketPosition, {
        passive: true
      });
      window.addEventListener('resize', requestUpdateBasketPosition);
      window.addEventListener('load', requestUpdateBasketPosition);
      setTimeout(requestUpdateBasketPosition, 200);
      setTimeout(requestUpdateBasketPosition, 600);
    };
    initDesktopBasketFollow();
    var mixer = mixitup(tiles, {
      selectors: {
        target: '.tile--unselected'
      },
      animation: {
        duration: 300
      },
      callbacks: {
        // Hold the height while tiles animate so the page doesn't jump
        onMixStart: function onMixStart() {
          $('.sf__solutions').css('height', $('.sf__solutions').height());
        },
        onMixEnd: function onMixEnd(state) {
          $('.sf__solutions').css('height', '').toggleClass('sf__solutions--empty', state.totalShow === 0 && $('#tiles > .tile').length > 0);
        }
      }
    });
    var sortableOptions = {
      group: 'shared',
      animation: 200,
      easing: "cubic-bezier(0.37, 0, 0.63, 1)"
    };

    // Drag and drop hijacks scrolling on touch screens, so desktop only
    var isMobile = function isMobile() {
      return window.innerWidth < 1024;
    };
    var tilesSortable = new Sortable(tiles, _objectSpread(_objectSpread({}, sortableOptions), {}, {
      onAdd: function onAdd(e) {
        e.item.classList.add('tile--unselected');
        e.item.classList.remove('tile--selected');
        refilter();
      }
    }));
    var dropzoneSortable = new Sortable(dropzone, _objectSpread(_objectSpread({}, sortableOptions), {}, {
      filter: ".basket__tip",
      onAdd: function onAdd(e) {
        removeBasketMessages();
        e.item.classList.add('tile--selected');
        e.item.classList.remove('tile--unselected');
        mixer.forceRefresh();
        basketFeedback($(e.item));
      },
      onRemove: function onRemove() {
        checkDropzoneEmpty();
        updateBasketCount();
      }
    }));
    var toggleSortable = function toggleSortable() {
      tilesSortable.option('disabled', isMobile());
      dropzoneSortable.option('disabled', isMobile());
    };
    toggleSortable();
    $(window).on('resize', toggleSortable);

    // Tile add button
    $('.tile > .fa-plus').on('click', function () {
      var tile = $(this).parent('.tile');
      addTileToBasket(tile);
    });

    // Tile remove button
    $('.tile > .fa-close').on('click', function () {
      var tile = $(this).parent('.tile');
      removeTileFromBasket(tile);
    });

    // Filter the solutions on select change
    $('#sectors, #applications, #bng').on('change', function (e) {
      var sector = $('#sectors :selected').val();
      var type = $('#applications :selected').val();
      var bng = $('#bng :selected').val();

      // Check if all are "all" or empty and show everything
      if ((!sector || sector === 'all') && (!type || type === 'all') && (!bng || bng === 'all')) {
        mixer.filter('all');
        return;
      }

      // Build combined selector with AND logic
      var selector = '';
      if (sector && sector !== 'all' && sector !== '') {
        selector += sector;
      }
      if (type && type !== 'all' && type !== '') {
        selector += type;
      }
      if (bng && bng !== 'all' && bng !== '') {
        selector += bng;
      }
      console.log('Filter selector:', selector);
      mixer.filter(selector);
    });

    // Close info box
    $('.info__remove, .tile__close, .sf__backdrop').on('click', function () {
      closeInfoBox();
    });

    // Open info box
    $('.tile__learn').on('click', function () {
      var id = $(this).attr('data-id');
      var $tile = $(this).closest('.tile');

      // Calculate tile position relative to the parent container
      var tileTop = $tile.position().top;

      // Position the info panel at the same height as the clicked tile
      $('.sf__info').css('top', tileTop + 'px');
      populateInfoBox(id);
      $('.sf__info').addClass('sf__info--show');
      $('.solutions__gui').addClass('popped');
      reserveInfoBoxSpace();
    });

    // Info add button
    $('.info__add').on('click', function () {
      var id = $('.sf__info').attr('data-id');
      var tile = $("#".concat(id));
      addTileToBasket(tile);
      closeInfoBox();
    });

    // The panel grows once its image loads, so re-measure
    $('.info__image').on('load', function () {
      if ($('.sf__info').hasClass('sf__info--show')) {
        reserveInfoBoxSpace();
      }
    });

    // Toast "View" opens the basket on mobile
    $('.basket__toast-view').on('click', function () {
      hideBasketToast();
      $('.sf__basket').addClass('sf__basket--open');
    });

    // Open basket on mobile
    $('.basket__mobile').on('click', function () {
      $('.sf__basket').toggleClass('sf__basket--open');
    });

    // Submit the basket and show the form
    $('.basket__submit').on('click', function () {
      if (!isBasketEmpty()) {
        nextStage($('.solutions__gui'), $('.solutions__details'));
        $('#dropzone > .tile').each(function () {
          var id = $(this).attr('id');
          var solution = solutions.find(function (solution) {
            return solution.id == id;
          });
          solution.selected = true;
        });
      }
    });

    // Submit the form and show the report
    $('.sf-form').submit(function (e) {
      e.preventDefault();
      nextStage($('.solutions__details'), $('.solutions__loader'));
      submitSolution(this);
    });
    var addTileToBasket = function addTileToBasket(tile) {
      removeBasketMessages();
      tile.appendTo('#dropzone');
      tile.addClass('tile--selected');
      tile.removeClass('tile--unselected');
      mixer.forceRefresh();
      basketFeedback(tile);
    };
    var removeTileFromBasket = function removeTileFromBasket(tile) {
      tile.appendTo('.sf__tiles');
      checkDropzoneEmpty();
      tile.removeClass('tile--selected');
      tile.addClass('tile--unselected');
      refilter();
      updateBasketCount();
    };

    // A tile returning from the basket must respect the current filter
    var refilter = function refilter() {
      mixer.forceRefresh();
      mixer.filter(mixer.getState().activeFilter.selector);
    };
    var closeInfoBox = function closeInfoBox() {
      $('.sf__info').removeClass('sf__info--show');
      $('.solutions__gui').removeClass('popped').css('padding-bottom', '');
    };

    // The info panel is absolutely positioned at the clicked tile, so pad the
    // section by however far it overhangs the tiles
    var reserveInfoBoxSpace = function reserveInfoBoxSpace() {
      var info = $('.sf__info');
      var solutions = $('.sf__solutions');
      // Read the target top, as the live value is still mid-transition
      var top = parseFloat(info[0].style.top) || 0;
      var overhang = top + info.outerHeight(true) - solutions.outerHeight();
      $('.solutions__gui').css('padding-bottom', Math.max(overhang, 0) + 40);
    };
    var updateBasketCount = function updateBasketCount() {
      var count = $('#dropzone > .tile').length;
      $('.basket__count').text(count).toggleClass('basket__count--show', count > 0);
    };
    var toastTimer;
    var hideBasketToast = function hideBasketToast() {
      clearTimeout(toastTimer);
      $('.basket__toast').removeClass('basket__toast--show');
    };

    // Visual confirmation that a tile has gone into the basket
    var basketFeedback = function basketFeedback(tile) {
      updateBasketCount();
      tile.removeClass('tile--added');
      void tile[0].offsetWidth; // restart the animation
      tile.addClass('tile--added');
      var tab = $('.basket__mobile');
      tab.removeClass('basket__mobile--bump');
      void tab[0].offsetWidth;
      tab.addClass('basket__mobile--bump');

      // The basket is off-canvas below desktop, so say what happened
      if (window.innerWidth < 1024 && !$('.sf__basket').hasClass('sf__basket--open')) {
        $('.basket__toast-title').text(tile.find('.tile__heading').text());
        $('.basket__toast').addClass('basket__toast--show');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(hideBasketToast, 4000);
      }
    };
    var checkDropzoneEmpty = function checkDropzoneEmpty() {
      if (!document.querySelector('.basket .tile')) {
        document.querySelector('.basket__tip').style.display = 'block';
      }
    };
    var removeBasketMessages = function removeBasketMessages() {
      document.querySelector('.basket__tip').style.display = 'none';
      $('.basket__empty').css('display', 'none');
    };
    var populateInfoBox = function populateInfoBox(id) {
      var solution = solutions.find(function (solution) {
        return solution.id == id;
      });
      $('.sf__info').attr('class', "sf__info info ".concat(solution.category_val));
      $('.sf__info').attr('data-id', solution.id);
      $('.info__image').attr('src', solution.image);
      $('.info__title').text(solution.title);
      $('.info__product_code').text(solution.categories);
      $('.info__excerpt').text(solution.excerpt);
      $('.info__applications').html(solution.applications);
      if (solution.page_link) {
        $('.info__link').css('display', 'block');
        $('.info__link').text("Read more about ".concat(solution.title));
        $('.info__link').attr('href', solution.page_link);
      } else {
        $('.info__link').css('display', 'none');
      }
    };
    var isBasketEmpty = function isBasketEmpty() {
      if (!$('#dropzone > .tile').length) {
        $('.basket__empty').css('display', 'block');
        return true;
      }
      return false;
    };
    var nextStage = function nextStage(current, next) {
      $('.sf__basket').removeClass('sf__basket--open');
      hideBasketToast();
      current.fadeOut(1000, function () {
        next.fadeIn(1000);

        // The previous stage may have been scrolled well past, so bring the new one into view
        var header = document.querySelector('header');
        var offset = (header ? header.offsetHeight : 0) + 20;
        window.scrollTo({
          top: Math.max(next.offset().top - offset, 0),
          behavior: 'smooth'
        });
      });
    };
    var loopIterations = 0;
    var loader = anime({
      targets: '.loader__circle',
      loop: true,
      autoplay: false,
      rotate: 360,
      duration: 2000,
      easing: 'linear',
      loopComplete: function loopComplete() {
        loopIterations++;
      }
    });
    var submitSolution = function submitSolution(form) {
      var selectedSolutions = solutions.filter(function (solution) {
        return solution.selected;
      });
      var selectedIDs = [],
        selectedTitles = [],
        selectedEbuildIds = [];
      selectedSolutions.map(function (solution) {
        selectedIDs.push(solution.id);
        selectedTitles.push(solution.title);
        selectedEbuildIds.push(solution.ebuild_id);
      });

      // Convert the form to an object for JSON encoding
      var formData = {};
      $(form).serializeArray().forEach(function (item) {
        formData[item.name] = item.value;
      });
      $.ajax({
        type: 'POST',
        url: ajax.ajax_url,
        data: {
          action: 'submit_solution',
          formData: JSON.stringify(formData),
          solutionIDs: JSON.stringify(selectedIDs),
          solutionTitles: JSON.stringify(selectedTitles),
          solutionEbuildIds: JSON.stringify(selectedEbuildIds)
        },
        beforeSend: function beforeSend() {
          loader.play();
        },
        success: function success(response) {
          var parsedResponse = jQuery.parseJSON(response);
          var isSuccess = parsedResponse['result'];
          new Promise(checkLoopIterations).then(function () {
            loader.pause();
            if (isSuccess) {
              nextStage($('.solutions__loader'), $('.solutions__report'));
              popuplateReport(selectedSolutions);
            } else {
              nextStage($('.solutions__loader'), $('.solutions__error'));
            }
          });
        },
        error: function error() {
          new Promise(checkLoopIterations).then(function () {
            loader.pause();
            nextStage($('.solutions__loader'), $('.solutions__error'));
          });
        }
      });
    };
    var checkLoopIterations = function checkLoopIterations(resolve, reject) {
      if (loopIterations >= 2) {
        resolve();
      } else {
        setTimeout(checkLoopIterations, 500, resolve, reject);
      }
    };
    var popuplateReport = function popuplateReport(selectedSolutions) {
      var firstName = $('#first-name').val();
      var isShare = $('input[name="share"]:checked').val() === 'yes';
      $('.report__title').html("Thanks ".concat(firstName, ", your selection is with our experts."));
      $('.solutions__subtitle').html("We've sent a confirmation email with your selection details. Our team will be in touch shortly to discuss next steps.");
      populateDetails(firstName);
      populatePackage(selectedSolutions);

      // Show shared details if applicable
      if (isShare) {
        var sharedHTML = "\n            <p class=\"report__detail-item\"><strong>Name:</strong> ".concat($('#recipient-fname').val(), " ").concat($('#recipient-lname').val(), "</p>\n            <p class=\"report__detail-item\"><strong>Email:</strong> ").concat($('#recipient-email').val(), "</p>\n        ");
        $('#report-shared-data').html(sharedHTML);
        $('#report-shared-section').show();
        var shareMsg = $('#share-message').val();
        if (shareMsg) {
          $('#report-share-message').text(shareMsg);
          $('#report-share-message-section').show();
        }
      }
    };
    var populateDetails = function populateDetails(firstName) {
      $('#report-fn').html("<strong>Name:</strong> ".concat(firstName, " ").concat($('#last-name').val()));
      $('#report-ea').html("<strong>Email:</strong> ".concat($('#email').val()));
      $('#report-pn').html("<strong>Phone:</strong> ".concat($('#phone').val()));
      $('#report-cn').html("<strong>Company:</strong> ".concat($('#company').val()));
      var projectMessage = $('#project-needs').val();
      if (projectMessage) {
        $('#report-user-message').text(projectMessage);
        $('#report-user-message-section').show();
      }
    };
    var populatePackage = function populatePackage(selectedSolutions) {
      if (sectorParam) {
        $('#sector-of-interest').toggle();
        $('#sector-of-interest span').append(sectorParam.replace('-', ' & '));
      }
      selectedSolutions.map(function (solution) {
        var tile = "\n                <div class=\"tile ".concat(solution.category_val, "\">\n                    <img src=\"").concat(solution.image, "\" />\n                    <p class=\"tile__tags\">").concat(solution.categories, "</p>\n                    <p class=\"tile__heading\">").concat(solution.title, "</p>\n                    <p class=\"tile__info\">").concat(solution.excerpt, "</p>\n                </div>\n            ");
        $('.report__tiles').append(tile);
      });
    };

    // Sort tiles by the initial sector query parameter
    if (sectorParam) {
      $('#sectors').val(".".concat(sectorParam)).change();
    }

    // Sort tiles by the initial id query parameter
    if (idsParam) {
      var ids = idsParam.split(',');
      var idFilterString = ids.map(function (id) {
        return "[data-id=\"".concat(id, "\"]");
      }).join(', ');
      mixer.filter(idFilterString);
    }
    $('input[name="share"]').on('change', function () {
      if ($(this).val() === "yes") {
        $("#shared-contact-fields").slideDown();
      } else {
        $("#shared-contact-fields").slideUp();
      }
    });
  }
});